var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('title-card'),_c('content-text')],1),_c('b-row',[_c('b-col',[_c('image-card')],1),_c('b-col',[_c('file-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }